export const MUSICNAME = "";  // 可以空，目前先不显示
